import React, { useState, useEffect, useForm } from "react";
import {
  Modal,
  Button,
  Input,
  Radio,
  Select,
  DatePicker,
  Checkbox,
  Form,
  Result,
} from "antd";
import Api from "../../../../services/ServiceApi";
import moment from "moment";
import Cookies from "js-cookie";
const dateFormat = "DD/MM/YYYY";

const { Option } = Select;
const BusDetailModal = ({ handleVisible }) => {
  const [busDetailData, setBusDatailData] = useState({});
  const [initData, setInitData] = useState({
    lineData: [],
    areaData: [],    
    divisionData: [],
    garageData: [],
    modelData: [],
    busGroupData: [],
    busTypeData: []
  });


  const [lineData, setLineData] = useState([]);


  const [form] = Form.useForm();

  useEffect(() => {

    setInitData(initData)
    console.log('useEffect setInitData',initData);

  }, {initData});

  useEffect(() => {
      // action on update
      // if(areaData !== undefined){
      //   setAreaData(areaData)
      // }

      const line_temp = []

      if(lineData !== undefined){
        setLineData(lineData)
      } 

}, [lineData]);
  useEffect(() => {
    Api.post("get_query_group_list", {
      "company_id" : "1" 
      ,"operator_id" : "3" 
      ,"project_id" : "1" 
      ,"query_id" : "1,2,3,4,5,6,7" 
      ,"query_module" : "bus"
      ,"param_text" : "" 
      ,"where_cond" : "" 
    }).then((res) => {
      console.log("get_query_group_list", res);
      
      
      const data = res.data.data

      let temp = {
        lineData: data.bus_line_list,
        areaData: data.area_list,    
        divisionData: data.division_list,
        garageData: data.garage_list,
        modelData: data.model_list,
        busGroupData: data.bus_group_list,
        busTypeData: data.bus_type_list
      }

      setInitData(temp);

    })
    .catch((e) => {
      console.log(e);
    });

    Api.post("getDetailBus", {
      bus_id: Cookies.get('selected_bus_id'),
    }).then((res) => {
      const data = res.data.data;
      setBusDatailData(res.data.data)
      form.setFieldsValue({
        advertisingType: [
          checkAdAvailable(data.two_d, "2D"),
          checkAdAvailable(data.three_d, "3D"),
          checkAdAvailable(data.led, "LED"),
          checkAdAvailable(data.reflective_film, "Film"),
        ],
        area: data.area_name,
        busContract: "test",
        busGroup: data.bus_group_id,
        busNO: data.bus_no,
        busType: data.bus_type_id,
        division: data.division_id,
        externalArea: [
          checkAdAvailable(data.fw, "FW"),
          checkAdAvailable(data.hw, "HW"),
          checkAdAvailable(data.qw, "QW"),
          checkAdAvailable(data.special, "SP"),
        ],
        garage: data.garage_id,
        internalArea: [
          checkAdAvailable(data.ib, "IB"),
          checkAdAvailable(data.hg, "HG"),
          checkAdAvailable(data.lcd, "LCD"),
        ],
        isAvailable: data.status_avaliable === "AVAILABLE" ? true : false,
        lineNO: data.bus_line_id,
        mediaID: data.media_id,
        model: data.model_id,
        plateNO: data.license_plate,
        remark: data.remark === null ? "" : data.remark,
        contractExpiredDate: data.contact_expire_date ? moment(data.contact_expire_date) : null
      });
    });
  }, {});

  const checkAdAvailable = (hasAd, value) => {
    if(hasAd === 1){
      return value
    }
  };
  // update bus in the end
  const sendBusDetail = async () => {
    const val = await form.validateFields();
    console.log(val);
    Api.post("updateBus", {
      "2D": SetDataFilter(val.advertisingType, "2D"),//1
      "3D": SetDataFilter(val.advertisingType, "3D"),//1,
      "FW": SetDataFilter(val.externalArea, "FW"), //1,
      "HG": SetDataFilter(val.internalArea, "HG"),//1,
      "HW": SetDataFilter(val.externalArea, "HW"),//1,
      "IB": SetDataFilter(val.internalArea, "IB"),//1,
      "QW": SetDataFilter(val.externalArea, "QW"),//1,//
      "LCD": SetDataFilter(val.internalArea, "LCD"),//1,//
      "LED": SetDataFilter(val.advertisingType, "LED"),//1,//
      "bus_id": Cookies.get('selected_bus_id'),
      "bus_no": val.busNO,//"6",//
      "remark": val.remark,//
      "Special": SetDataFilter(val.externalArea, "SP"),//0,//
      "image_id": null,
      "media_id": val.mediaID,//"Bus 3318",//
      "model_id": val.model,//24
      "create_by": Cookies.get("userId"),//123,
      "area_id":  val.area,
      "division_id": val.division,
      "garage_id": val.garage,//55
      "is_active": 1,//
      "bus_status": busDetailData.bus_status ? "1" : "0",//
      "sub_status": busDetailData.sub_status,//null,
      "status_avaliable": val.isAvailable  ? "AVAILABLE" : "NOT AVAILABLE",
      "bus_line_id": val.lineNO ,//107
      "bus_type_id": val.busType,//4
      "create_date": "2021-05-07 12:23:27.000000",
      "bus_group_id": val.busGroup,//1
      // "has_contract": val.isAvailable ? "1" : "0",//0,//
      "license_plate": val.plateNO,//
      "has_bus_patent": busDetailData.has_bus_patent,//1,//
      "Reflective_film": SetDataFilter(val.advertisingType, "Film"),//1//
      "contact_expire_date": val.contractExpiredDate ?moment(val.contractExpiredDate).format("YYYY-MM-DD") : null
    }).then(res => {
      if (res.data.result.code === "P" || res.data.data === "update bus success") {
        form.resetFields();
        handleVisible(false);
        alert("UPDATE SUCCESS")
        window.location.reload(false);     
      }
    })
  };

  
  const SetDataFilter = (obj, value) => {
    const result = obj.filter(data => data === value);

    if (result.length > 0) {
      return "1"
    } else {
      return "0"
    }

  }

  return (
    <Modal
      title="Bus Detail"
      visible={true}
      onCancel={() => handleVisible(false)}
      onOk={() => handleVisible(false)}
      width={850}
      footer={[
        <div className="text-center">
          {[
            <Button key="Cancel" onClick={() => handleVisible(false)}>
              Cancel
            </Button>,
            <Button
              key="Add"
              className="btn-warning"
              style={{ background: "#E8CD00" }}
              onClick={() => sendBusDetail()}
            >
              Confirm
            </Button>,
          ]}
        </div>,
      ]}
    >
      <Form form={form}>
        <div>
          {/* Status */}
          <div className="row">
            <div
              className="d-flex align-items-end justify-content-between"
              style={{ width: "100%" }}
            >
              <div className="col-4">
                <div className="mb-3">Status</div>
                <div>
                  <Form.Item name="isAvailable">
                    <Radio.Group onChange={() => console.log("change status")}>
                      <Radio value={true}>Available</Radio>
                      <Radio value={false}>Not Available</Radio>
                    </Radio.Group>
                  </Form.Item>
                </div>
                <br />

                <span>Plate No.</span>
                <br />
                <Form.Item name="plateNO">
                  <Input placeholder="Please input" />
                </Form.Item>
              </div>
              <div className="col-4">
                <span>Line No.</span>
                <br />
                {/* <Form.Item name="lineNO">
                  <Input placeholder="Please input" />
                </Form.Item> */}
                <Form.Item name="lineNO">
                <Select
                  showSearch
                  style={{ width: "16vw" }}
                  placeholder="Please select"
                  filterOption={(input, option) =>
                    option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                  }
                >
                  {/* {(() => {
                    const options = [];

                    for (let i = 0; i <= lineData.length; i++) {
                      options.push(<option value={lineData[i].bus_line_id}>{lineData[i].bus_line_name}</option>);
                    }

                    return options;
                  })()} */}
                  {console.log(initData)}
                  {initData.lineData.map((data, index) => (
                    <Option
                      key={`line_${index}`}
                      value={data.bus_line_id}
                    >
                      {data.bus_line_name}
                    </Option>
                  ))}
                </Select>
              </Form.Item>

              </div>
              <div
                className="col-4 mb-2"
                style={{ marginRight: "2vw", textAlign: "center" }}
              >
                    <div>
                        <div className="upload-text">
                            <span >128 x 128</span>
                        </div>
                        <div className="upload-icon-poi">
                           <img src={Api.absoluteUrl("/img/picture_icon.svg")}   width="50px"/>
                        </div>
                    </div>
              </div>
            </div>
          </div>
          {/* Area Division Garage */}
          <div className="row mb-3">
            <div className="col-4">
              <span>Area</span>
              <br />

              <Form.Item name="area">
                <Select
                  showSearch
                  style={{ width: "16vw" }}
                  placeholder="Please select"
                >

                  {initData.areaData.map((data, index) => (
                    <Option
                      key={`area_${index}`}
                      value={data.area_id}
                    >
                      {data.area_name}
                    </Option>
                  ))}
                </Select>
              </Form.Item>
            </div>
            <div className="col-4">
              <span>Division</span>
              <br />
              <Form.Item name="division">
                <Select
                  showSearch
                  style={{ width: "16vw" }}
                  placeholder="Please select"
                >

                  {initData.divisionData.map((data, index) => (
                    <Option
                      key={`division_${index}`}
                      value={data.division_id}
                    >
                      {data.division_name}
                    </Option>
                  ))}
                </Select>
              </Form.Item>
            </div>
            <div className="col-4">
              <span>Garage</span>
              <br />
              <Form.Item name="garage">
                <Select
                  showSearch
                  style={{ width: "16vw" }}
                  placeholder="Please select"
                >
                  {initData.garageData.map((data, index) => (
                    <Option
                      key={`garage_${index}`}
                      value={data.garage_id}
                    >
                      {data.garage_name}
                    </Option>
                  ))}
                </Select>
              </Form.Item>
            </div>
          </div>
          {/* Bus No. Model Bus Group */}
          <div className="row mb-3">
            <div className="col-4">
              <span>Bus No.</span>
              <br />
              <Form.Item name="busNO">
                <Input placeholder="Please input" />
              </Form.Item>
            </div>
            <div className="col-4">
              <span>Model</span>
              <br />
              <Form.Item name="model">
                <Select
                  showSearch
                  style={{ width: "16vw" }}
                  placeholder="Please select"
                >
                  {initData.modelData.map((data, index) => (
                    <Option
                      key={`model_${index}`}
                      value={data.model_id}
                    >
                      {data.model_name}
                    </Option>
                  ))}
                </Select>
              </Form.Item>
            </div>
            <div className="col-4">
              <span>Bus Group</span>
              <br />
              <Form.Item name="busGroup">
                <Select
                  showSearch
                  style={{ width: "16vw" }}
                  placeholder="Please select"
                >
                  {initData.busGroupData.map((data, index) => (
                    <Option
                      key={`busGroup_${index}`}
                      value={data.bus_group_id}
                    >
                      {data.bus_group_name}
                    </Option>
                  ))}
                </Select>
              </Form.Item>
            </div>
          </div>
          {/* Bus Type Media ID Bus Contract*/}
          <div className="row mb-3">
            <div className="col-4">
              <span>Bus Type</span>
              <br />
              <Form.Item name="busType">
                <Select
                  showSearch
                  style={{ width: "16vw" }}
                  placeholder="Please select"
                >
                  {initData.busTypeData.map((data, index) => (
                    <Option
                      key={`busType_${index}`}
                      value={data.bus_type_id}
                    >
                      {data.bus_type_name}
                    </Option>
                  ))}
                  {/* <Option value="1">บีแอลเค</Option>
                  <Option value="2">ยูโร</Option> */}
                </Select>
              </Form.Item>
              {/* <Form.Item name="busType">
                <Input placeholder="Please input" />
              </Form.Item> */}
            </div>
            <div className="col-4">
              <span>Media ID</span>
              <br />
              <Form.Item name="mediaID">
                <Input placeholder="Please input" />
              </Form.Item>
            </div>
            {/* <div className="col-4">
              <span>Bus Contract</span>
              <br />
              <Form.Item name="busContract">
                <Select
                  showSearch
                  style={{ width: "16vw" }}
                  placeholder="Please select"
                >
                  <Option value="A">Contract A</Option>
                  <Option value="B">Contract B</Option>
                  <Option value="C">Contract C</Option>
                </Select>
              </Form.Item>
            </div> */}
          </div>
          {/* Contract expired Remark */}
          <div className="row mb-3">
            <div className="col-4">
              <span>Contract Expired</span>
              <Form.Item name="contractExpiredDate">
                <DatePicker
                  placeholder="Please select"
                  style={{ width: "100%" }}
                  format={dateFormat}
                />
              </Form.Item>
              <br />
            </div>
            <div className="col-8">
              <span>Remark</span>
              <br />
              <div>
                <Form.Item name="remark">
                  <Input placeholder="Please input" style={{ width: "100%" }} />
                </Form.Item>
              </div>
            </div>
          </div>
          {/* Edxternal Area   4choice */}
          <div className="row">
            <div className="col-12">
              <div className="mb-2">External Area</div>
              <div>
                <Form.Item name="externalArea">
                  <Checkbox.Group>
                    <Checkbox value="FW">External - FW</Checkbox>
                    <Checkbox value="HW">External - HW</Checkbox>
                    <Checkbox value="QW">External - QW</Checkbox>
                    <Checkbox value="SP">External - Special</Checkbox>
                  </Checkbox.Group>
                </Form.Item>
              </div>
            </div>
          </div>
          {/* internal area 3 choice*/}
          <div className="row">
            <div className="col-12">
              <div className="mt-2 mb-2">Internal Area</div>
              <div>
                <Form.Item name="internalArea">
                  <Checkbox.Group>
                    <Checkbox value="IB">Internal - In Bus</Checkbox>
                    <Checkbox value="HG">Internal - Hangar</Checkbox>
                    <Checkbox value="LCD">Internal - LCD</Checkbox>
                  </Checkbox.Group>
                </Form.Item>
              </div>
            </div>
          </div>
          {/* Advertisnng Type */}
          <div className="row">
            <div className="col-12">
              <div className="mt-2 mb-2">Advertising Type</div>
              <div>
                <Form.Item name="advertisingType">
                  <Checkbox.Group>
                    <Checkbox value="2D">2D</Checkbox>
                    <Checkbox value="3D">3D</Checkbox>
                    <Checkbox value="LED">lightning</Checkbox>
                    <Checkbox value="Film">Reflective Film</Checkbox>
                  </Checkbox.Group>
                </Form.Item>
              </div>
            </div>
          </div>
        </div>
      </Form>
    </Modal>
  );
};

export default BusDetailModal;
